import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=642b195a&scoped=true&"
import script from "./TestView.vue?vue&type=script&lang=js&"
export * from "./TestView.vue?vue&type=script&lang=js&"
import style0 from "./TestView.vue?vue&type=style&index=0&id=642b195a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b195a",
  null
  
)

export default component.exports